import React from 'react';

export const TicketGrayIcon = () => {
    return (
        <svg width="46" height="26" viewBox="0 0 46 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.1639 26L42.6157 26C44.3847 26 45.8185 24.5662 45.8185 22.7972L45.8185 17.2707C43.4601 17.2707 41.548 15.3586 41.548 13.0002C41.548 10.6418 43.4601 8.72962 45.8185 8.72962L45.8185 3.20319C45.8185 1.43419 44.3847 0.000354832 42.6157 0.000354678L15.1639 0.000352278L15.1639 26Z"
                fill="#B4B5BC"
            />
            <path
                d="M0.306381 17.2704C0.203337 17.2704 0.100997 17.2665 6.17993e-05 17.2595L6.13152e-05 22.7972C6.11605e-05 24.5662 1.43389 26 3.20289 26L14.164 26L14.164 5.91293e-06L3.20289 4.95468e-06C1.4339 4.80003e-06 6.31828e-05 1.43384 6.30281e-05 3.20284L6.2544e-05 8.74053C0.101348 8.73349 0.203337 8.72962 0.306382 8.72962C2.66481 8.72962 4.57694 10.6418 4.57694 13.0002C4.57694 15.3586 2.66481 17.2704 0.306381 17.2704Z"
                fill="#B4B5BC"
            />
        </svg>
    );
};
